export const EVENT_ROCKET_RUNNING = "EVENT_ROCKET_RUNNING";
export const EVENT_ROCKET_LOAD = "EVENT_ROCKET_LOAD";
export const EVENT_ROCKET_MATCH_END = "EVENT_ROCKET_MATCH_END";
